import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Product } from '@common/product';
import { CommonModule } from '@angular/common';
import { Category } from '@common/category';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { loadProducts } from '@app/state/products/products.actions';
import {
  selectAllProducts,
  selectProductsLoading,
} from '@app/state/products/products.selectors';
import { loadPublicCategories } from '@app/state/categories/public-categories.actions';
import { selectAllPublicCategories } from '@app/state/categories/public-categories.selectors';

import { HeroSectionComponent } from './hero-section/hero-section.component';
import { DecantingVideoBannerComponent } from './decanting-video-banner/decanting-video-banner.component';
import { FeaturedProductsComponent } from './featured-products/featured-products.component';
import { CategoriesHighlightComponent } from './categories-highlight/categories-highlight.component';
import { BenefitsComponent } from './benefits/benefits.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { CtaSectionComponent } from './cta-section/cta-section.component';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    HeroSectionComponent,
    DecantingVideoBannerComponent,
    FeaturedProductsComponent,
    CategoriesHighlightComponent,
    BenefitsComponent,
    TestimonialsComponent,
    CtaSectionComponent,
  ],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  private readonly store = inject(Store);

  products$: Observable<Product[]> = this.store
    .select(selectAllProducts)
    .pipe(map((products) => products.slice(0, 4)));
  isLoading$: Observable<boolean> = this.store.select(selectProductsLoading);
  categories$: Observable<Category[]> = this.store.select(
    selectAllPublicCategories,
  );

  ngOnInit(): void {
    this.store.dispatch(
      loadProducts({
        criteria: { page: 0, size: 4, sort: 'dateCreated,desc' },
      }),
    );
    this.store.dispatch(loadPublicCategories());
  }

  trackByProductId(index: number, product: Product): number {
    return product.id;
  }
}
